// src/components/DetailList.jsx
export function DetailList({ text }) {
  const hasText = !!text;

  const renderListItems = () => {
    return text
      .split('\n\n')
      .filter(Boolean)
      .flatMap((paragraph, paraIndex) =>
        paragraph
          .split('\n')
          .filter(Boolean)
          .map((item, itemIndex) => (
            <li key={`${paraIndex}-${itemIndex}`} className="my-2 last:mb-0">
              {item.replace(/^- /, '').trim()}
            </li>
          ))
      );
  };

  return (
    <div>
      {hasText ? (
        <ul className="list-disc list-outside space-y-2 pl-6 leading-relaxed text-[#0A0A0A] text-base">
          {renderListItems()}
        </ul>
      ) : (
        <p className="text-[#0A0A0A] text-base">No data available.</p>
      )}
    </div>
  );
}
